import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';

// ─────────────────────────────────────────────────────────────────────────────
// 17. EXPIRY ALERTS PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const ExpiryAlertsPage = ({ companyId }) => {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [days, setDays]       = useState(30);
  const { show, ToastEl }     = useToast();

  const fetchData = async () => {
    setLoading(true);
    const res = await productController.getExpiring(days, companyId);
    if (res.success) setData(res.data);
    else show(res.message, 'error');
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, [companyId, days]);

  return (
    <div style={S.page}>
      {ToastEl}
      <PageHeader title="Expiry Alerts" subtitle="Products expiring soon" Icon={Receipt} color={C.orange}
        action={
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <select style={{ ...S.select, width:'auto', padding:'8px 12px' }} value={days} onChange={e=>setDays(Number(e.target.value))}>
              {[7,15,30,60,90].map(d=><option key={d} value={d}>Next {d} days</option>)}
            </select>
            <button style={S.btnSec} onClick={fetchData}><RefreshCw size={15}/> Refresh</button>
          </div>
        } />
      <div style={S.card}>
        {loading ? <div style={S.center}>Loading...</div> : (
          <div style={{ overflowX:'auto' }}>
            <table style={S.table}>
              <thead><tr>{['Product','SKU','Batch No.','Expiry Date','Days Left','Current Stock','Warehouse','Status'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {data.map((p,i)=>{
                  const daysLeft = p.expiryDate ? Math.ceil((new Date(p.expiryDate)-new Date())/(1000*86400)) : null;
                  const expired  = daysLeft !== null && daysLeft <= 0;
                  return (
                    <tr key={p.id||i} style={{ background: expired ? '#fff5f5' : '#fff7ed' }}>
                      <td style={S.td}><div style={{ fontWeight:700 }}>{p.name}</div></td>
                      <td style={S.td}><span style={{ fontFamily:'monospace', fontSize:12 }}>{p.sku||'—'}</span></td>
                      <td style={S.td}><span style={{ fontFamily:'monospace', fontSize:12 }}>{p.batchNumber||'—'}</span></td>
                      <td style={S.td}><span style={{ color: expired ? C.danger : C.orange, fontWeight:600 }}>{fmt(p.expiryDate)}</span></td>
                      <td style={S.td}><Badge color={expired?C.danger:C.orange} bg={expired?'#fee2e2':'#fff7ed'}>{expired ? 'Expired' : `${daysLeft} days`}</Badge></td>
                      <td style={S.td}>{p.currentStock} {p.unitName||''}</td>
                      <td style={S.td}>{p.warehouseName||'—'}</td>
                      <td style={S.td}><Badge color={expired?C.danger:C.orange} bg={expired?'#fee2e2':'#fff7ed'} dot>{expired?'Expired':'Expiring Soon'}</Badge></td>
                    </tr>
                  );
                })}
                {!data.length && <tr><td colSpan={8}><div style={S.center}>✅ No products expiring in next {days} days</div></td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default ExpiryAlertsPage;